import { useMemo } from "react";
import { ExpandableTextContent } from "../../../shadcn/components/custom/ExpandableTextContent";
import { Card } from "../../../shadcn/components/ui/card";

export default function PDPublicNoticeAggregationDisclaimer() {
  const textContent = useMemo(
    () => (
      <div className="space-y-3">
        <p className="p-1 font-openSans font-normal text-brand-textLightGrey text-xs leading-4 tracking-wide">
          AuctionBazaar.com is an independent online marketplace that aggregates
          and displays auction-related information that is already available in
          the public domain through statutory notices, lender publications,
          government notifications, and other publicly accessible sources. We do
          not claim any association, authorization, mandate, or affiliation with
          any bank, financial institution, ARC, NBFC, or lender unless expressly
          stated.
        </p>
        <p className="p-1 font-openSans font-normal text-brand-textLightGrey text-xs leading-4 tracking-wide">
          All information is hosted solely for informational and
          bidder-awareness purposes, without any alteration to the content of
          the public notice. AuctionBazaar.com does not publish confidential,
          internal, or non-public documents of any lender. The platform does not
          conduct auctions on behalf of lenders unless formally appointed, and
          does not guarantee the accuracy or completeness of the information
          published in such public notices. Users are advised to independently
          verify all auction details with the concerned lender before
          participating in any auction process. By using this platform, users
          acknowledge that AuctionBazaar.com operates strictly as a
          public-domain information aggregator, and not as an agent,
          representative, or authorized partner of any lender, unless
          specifically mentioned.
        </p>
      </div>
    ),
    [],
  );
  return (
    <Card className="p-3 bg-white shadow-card-shadow border-none rounded-[10px]">
      <ExpandableTextContent
        title="Public Notice Aggregation Disclaimer"
        textContent={textContent}
      />
    </Card>
  );
}
